import { apiClient } from "./apiClient";

const isNotFoundInitialData = (error) => {
  return (
    error?.message?.includes("찾을 수 없습니다") ||
    error?.message?.includes("존재하지") ||
    error?.message?.includes("사이트을 찾을 수 없습니다")
  );
};

// 소통 관리 조회
export const getSiteContact = async () => {
  try {
    const result = await apiClient("/api/contact/site", {
      method: "GET",
    });

    return result.data;
  } catch (error) {
    if (isNotFoundInitialData(error)) {
      console.log("저장된 소통 관리 정보가 없어 빈 값으로 시작합니다.");
      return null;
    }

    throw error;
  }
};

// 소통 관리 저장
export const saveSiteContact = async (data) => {
  const result = await apiClient("/api/contact/site", {
    method: "POST",
    body: JSON.stringify(data),
  });

  return result.data;
};

// FAQ 목록 조회
export const getFaqList = async () => {
  try {
    const result = await apiClient("/api/contact/faq", {
      method: "GET",
    });

    return result.data;
  } catch (error) {
    if (isNotFoundInitialData(error)) {
      return [];
    }

    throw error;
  }
};

// FAQ 저장
export const saveFaqList = async (faqList) => {
  const result = await apiClient("/api/contact/faq", {
    method: "POST",
    body: JSON.stringify({
      faqs: faqList,
    }),
  });

  return result.data;
};

// 메인 배너 목록 조회
export const getMainBanners = async () => {
  try {
    const result = await apiClient("/api/contact/banner", {
      method: "GET",
    });

    return result.data;
  } catch (error) {
    if (isNotFoundInitialData(error)) {
      return [];
    }

    throw error;
  }
};

// 메인 배너 저장
export const saveMainBanners = async (files = [], keepBannerIds = []) => {
  const formData = new FormData();

  files.forEach((file) => {
    formData.append("files", file);
  });

  keepBannerIds.forEach((id) => {
    formData.append("keepBannerIds", id);
  });

  try {
    const result = await apiClient("/api/contact/banner", {
      method: "POST",
      body: formData,
    });

    return result.data;
  } catch (error) {
    console.error("메인 배너 저장 API 실패:", error);
    throw new Error(
      error.message ||
        "메인 배너 저장 요청은 전송되었지만 서버 파일 업로드 설정 문제로 저장에 실패했습니다."
    );
  }
};